import { useIntl } from 'react-intl';
import Table from 'src/componentes/table';
import { Row, Col } from 'reactstrap';
import Button from 'src/componentes/button';
import { capitalizeFirstLetter } from 'src/utils/string';
import useAuth from 'src/hooks/useAuth';
import { TIPO_ITENS } from 'src/utils/constants';
import LucideIcon from 'src/componentes/lucide-icon';

const ItensAssociados = ({ model, allowNew, handleNewClick }) => {
  const { terms: resources } = useAuth();
  const intl = useIntl();

  const handleRemove = (index) => {
    let novaLista = [...model.value]; // Cópia do array para evitar mutação direta
    novaLista.splice(index, 1);
    model.requestChange(novaLista);
  };

  const getTipo = (string) => {
    let tipo = '';
    for (let i = 0; i < string.length; i++) {
      const char = string[i];
      if (char !== '{' && char !== '}') tipo += char;
    }
    return tipo;
  };

  const getLabelTipo = (item, resources, intl) => {
    if (item.tipo && item.tipo.id === TIPO_ITENS.INDICADOR_RISCO) {
      return capitalizeFirstLetter(
        intl.formatMessage(
          { id: item.tipo.descricao },
          { risco: resources.risco }
        )
      );
    }

    return (
      item.tipo &&
      capitalizeFirstLetter(
        item.tipoNome ? item.tipoNome : resources[getTipo(item.tipo.descricao)]
      )
    );
  };

  return (
    <div>
      <Row>
        <Col md={6}>
          {model.label && (
            <label className="control-label">{model.label}</label>
          )}
        </Col>
        <Col md={6}>
          {allowNew && (
            <Button
              className="pull-right"
              type="primary"
              style={{ marginBottom: 10 }}
              onClick={handleNewClick}
            >
              <LucideIcon icon="Search" size={14} className="mr-1" />
              {intl.formatMessage({ id: 'label.buscar' })}
            </Button>
          )}
        </Col>
      </Row>
      {model.value && model.value.length > 0 ? (
        <Table>
          <thead>
            <tr>
              <th>{intl.formatMessage({ id: 'nome' })}</th>
              <th>{intl.formatMessage({ id: 'label.tipoDoItem' })}</th>
              <th>{capitalizeFirstLetter(resources.responsaveis)}</th>
              <th>{capitalizeFirstLetter(resources.area)}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {model.value.map((item, index) => (
              <tr key={index}>
                <td>{item.nome}</td>
                <td>{getLabelTipo(item, resources, intl)}</td>
                <td>{item.responsaveis}</td>
                <td>{item.area}</td>
                <td style={{ width: 40 }}>
                  {allowNew && (
                    <LucideIcon
                      icon="XCircle"
                      style={{ cursor: 'pointer' }}
                      size={18}
                      className="clarear"
                      onClick={() => handleRemove(index)}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <i>{intl.formatMessage({ id: 'label.naoHaItensRelacionados' })}</i>
      )}
    </div>
  );
};

export default ItensAssociados;
